import * as React from 'react';
import { AdImageFieldsFragment } from 'types/generated';
import { motion } from 'framer-motion';
import { bezierEase } from '@/utils/utils';
import clsx from 'clsx';
import Link from 'next/link';

type Props = {
  data: AdImageFieldsFragment;
};

const media = ({ data }: Props) => {
  if (data.media) {
    return (
      <video
        playsInline
        autoPlay
        loop
        muted
        id="nav-media"
        style={{
          minWidth: '100%',
          minHeight: '100%',
          zIndex: 1,
          objectFit: 'cover',
          width: '100%',
          height: 'auto',
          top: '50%',
          transform: ' translateY(-50%)',
          position: 'absolute',
        }}
      >
        <source src={data.media.url || ''} type="video/mp4" />
      </video>
    );
  }
  if (data.image?.image?.url) {
    return (
      <img
        src={data.image.image.url}
        alt={data.image?.image?.title || ''}
        style={{
          minWidth: '100%',
          minHeight: '100%',
          zIndex: 1,
          objectFit: 'cover',
          width: '100%',
          height: 'auto',
          top: '50%',
          transform: ' translateY(-50%)',
          position: 'absolute',
        }}
      />
    );
  }
  return null;
};

const MediaBoxWithFade = ({ data }: Props) => {
  return (
    <Link href={data.uri || ''}>
      <motion.div
        className="relative flex h-full min-w-[260px] max-w-[380px] self-stretch"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { ease: bezierEase, duration: 0.24 } }}
        exit={{ opacity: 0, transition: { ease: bezierEase, duration: 0.12 } }}
      >
        {media({ data })}
        <div
          className={clsx(
            'relative z-10 flex h-full min-w-[340px] max-w-[380px] flex-col items-start gap-sm self-stretch rounded-16 p-xl',
            {
              'brand-fade': data.mediaGradient,
            }
          )}
        >
          <div className="justify-space-between absolute bottom-16 z-10 flex flex-col items-start p-lg">
            <div className="relative flex flex-col items-start gap-xs self-stretch pb-lg">
              <div className="flex flex-col items-start gap-sm self-stretch pl-sm">
                <p className="title-sm self-stretch">{data.overline}</p>
                <p className="title-lg">{data.title}</p>
                <p className="title-sm">{data.subtitle}</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </Link>
  );
};

export default MediaBoxWithFade;
